import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const servicedeskCmdbAssetsObjectTypeConfigurationRoute: InvariantJiraRoute = {
	name: 'servicedesk-cmdb-object-type-configuration',
	path: '/jira/servicedesk/assets/configure/object-type/:objectTypeId',
};
